export const messages = {
  placeholder: 'Ближайший населённый пункт',
  error: {
    incorrectCity: 'Выберите ближайший населенный пункт к месту ведения бизнеса',
  },
}
